import SingleAddMember from './SingleAddMember.component';

export default SingleAddMember;